import { createSlice } from "@reduxjs/toolkit";
import {
    fetchQuestionTypeTableColumnNames,
    fetchAllQuestionType,
    createQuestionType,
    updateQuestionType,
    deleteQuestionType,
    activateDeactivateQuestionType,
    uploadQTypeImageIcon
} from "./thunk";
import { toast } from "react-toastify";

const questionTypeSlice = createSlice({
  name: "QuestionType",
  initialState: {
    questionType: [],
    tableColumnNames: [],
    uploadedImageUrl: null,
    loading: false,
    Headerload: false,
    imageload: false,
    error: null,
  },
  reducers: {
      clearUploadedQTypeImageUrl: (state) => {
        state.uploadedImageUrl = null;
      }
  },
  extraReducers: (builder) => {
    builder

      // Fetch Question Type Table Column Names
      .addCase(fetchQuestionTypeTableColumnNames.pending, (state) => {
        state.Headerload = true;
        state.error = null;
      })
      .addCase(fetchQuestionTypeTableColumnNames.fulfilled, (state, action) => {
        state.Headerload = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchQuestionTypeTableColumnNames.rejected, (state, action) => {
        state.Headerload = false;
        state.error = action.payload;
      })

      // Get All Question Type
      .addCase(fetchAllQuestionType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllQuestionType.fulfilled, (state, action) => {
        state.loading = false;
        state.questionType = action.payload;
      })
      .addCase(fetchAllQuestionType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Question Type
      .addCase(createQuestionType.pending, (state) => {
        state.error = null;
      })
      .addCase(createQuestionType.fulfilled, (state, action) => {
        state.questionType = [action.payload.data[0], ...state.questionType];
      })
      .addCase(createQuestionType.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Question Type
      .addCase(updateQuestionType.pending, (state) => {
        state.error = null;
      })
      .addCase(updateQuestionType.fulfilled, (state, action) => {
        const index = state.questionType.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.questionType[index] = action.payload[0];
        }

      })
      .addCase(updateQuestionType.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Question Type
      .addCase(deleteQuestionType.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteQuestionType.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.questionType = state.questionType.filter(
          (item) => !deletedIds.includes(item.ID)
        );

      })
      .addCase(deleteQuestionType.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Active Deactive Question Type
      .addCase(activateDeactivateQuestionType.pending, (state) => {
        state.error = null;
      })
      .addCase(activateDeactivateQuestionType.fulfilled, (state, action) => {
        if (action.payload) {
          const updatedQuestionType = action.payload[0];

          state.questionType = state.questionType.map((item) => item.ID === updatedQuestionType.ID ? {...item, IsActive: updatedQuestionType.IsActive} : item)
        }
      })
      .addCase(activateDeactivateQuestionType.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Question type  Image Icon
      .addCase(uploadQTypeImageIcon.pending, (state) => { 
        state.imageload = true;
        state.error = null;
      })
      .addCase(uploadQTypeImageIcon.fulfilled, (state, action) => {
        state.imageload = false;
        state.uploadedImageUrl = action.payload; 
      })
      .addCase(uploadQTypeImageIcon.rejected, (state, action) => {
        state.imageload = false;
        state.error = action.payload;
      })
    },
});
export const { clearUploadedQTypeImageUrl } = questionTypeSlice.actions; 
export default questionTypeSlice.reducer;
